import {
  checkforNestedGroups,
  addCondition,
  removeCondition,
  removeGroup,
  adjustOperators,
} from './builderContextHelpers';

export default (state, action) => {
  switch (action.type) {
    case 'REFRESH': {
      return action.payload;
    }

    case 'SET_LOGIC': {
      return {
        ...state,
        logic: action.payload,
      };
    }

    case 'SET_CONFIG': {
      return {
        ...state,
        config: action.payload,
      };
    }

    case 'SET_VERSION': {
      return {
        ...state,
        newVersion: action.payload,
      };
    }

    case 'SET_SQL': {
      return {
        ...state,
        sqlWhere: action.payload,
      };
    }

    case 'SET_FIELD': {
      return {
        ...action.payload,
      };
    }
    case 'SET_DISPLAY': {
      return {
        ...state,
        display: action.payload,
      };
    }

    case 'SET_SHOWERROR': {
      return {
        ...state,
        showError: action.payload,
      };
    }

    case 'SET_AUDIENCE_BUILDER': {
      return {
        ...state,
        advanced: action.payload,
      };
    }

    case 'SET_GROUPS': {
      // console.log("Called from Set Groups", action.payload)
      // const cleangroup =
      const updatedOperators = { ...state.operators };
      const groupIndex = action.payload.groupIndex;
      // const groups = action.payload.group?.filter(element => element !== undefined);
      const groups = action.payload.group;
      if (Array.isArray(groupIndex)) {
        // const currentList = action.payload.currentList?.filter(element => element !== undefined);
        const currentList = action.payload.currentList;
        const tempList = [...state.groups];
        const _groupIndex = [...groupIndex];
        const lastIndex = _groupIndex.pop();
        const lastArr = _groupIndex.reduce((arr, i) => {
          return arr[i]['children'];
        }, tempList);

        // const filteredCurrentList = currentList.filter(item => item.type !== "group")
        lastArr[lastIndex]['children'] = currentList;
        adjustOperators(tempList, updatedOperators);
        return { ...state, groups: tempList, operators: updatedOperators };
      }
      checkforNestedGroups(state.groups);
      adjustOperators(groups, updatedOperators);
      return { ...state, groups, operators: updatedOperators };
    }

    case 'ADD_CONDITION': {
      const { conditionId, groupId } = action.payload;
      const updatedGroups = [...state.groups];
      // Call a helper function to update state.groups based on groupId
      // updateGroup function return new deep copy of passed array
      const newGroups = addCondition(updatedGroups, groupId, conditionId);
      const updatedConditions = {
        ...state.conditions,
        [conditionId]: {
          id: conditionId,
          attribute: [],
          variables: [],
          option: 'include',
        },
      };
      const updatedOperators = { ...state.operators };
      adjustOperators(newGroups, updatedOperators);
      return {
        ...state,
        groups: newGroups,
        conditions: updatedConditions,
        operators: updatedOperators,
      };
    }

    case 'REMOVE_CONDITION': {
      const { conditionId, groupId } = action.payload;
      const updatedGroups = [...state.groups];
      let updatedConditions = { ...state.conditions };
      delete updatedConditions[conditionId];
      let newGroups = removeCondition(updatedGroups, groupId, conditionId);
      let updatedOperators = { ...state.operators };
      adjustOperators(newGroups, updatedOperators);
      const lastGroup = updatedGroups.filter(
        (group) => group.children?.length > 0
      ).length;
      if (lastGroup === 0) {
        newGroups = [
          {
            id: 'main',
            type: 'group',
            children: [{ id: 'condition-2', type: 'condition', children: [] }],
          },
        ];
        updatedConditions = {
          'condition-2': {
            id: 'condition-2',
            attribute: [],
            variables: [],
            option: 'include',
          },
        };
        updatedOperators = {};
      }
      return {
        ...state,
        groups: newGroups,
        conditions: updatedConditions,
        operators: updatedOperators,
      };
    }

    case 'MODIFY_CONDITION': {
      const updatedConditions = { ...state.conditions };
      const idToModify = action.payload.id;
      const fieldToModify = action.payload.parameter;
      const updatedCondition = {
        ...updatedConditions[idToModify],
        ...fieldToModify,
      };

      return {
        ...state,
        conditions: { ...updatedConditions, [idToModify]: updatedCondition },
      };
    }

    case 'GROUPS_NUMBER_UPDATE': {
      let newGroupsCount = state.numberOfGroups + action.payload;

      return {
        ...state,
        numberOfGroups: newGroupsCount,
      };
    }

    case 'SET_LOGICAL_OPERATOR': {
      const id = action.payload.id;
      const value = action.payload.value;
      const newLogicalOperators = [...state.logicalOperators];
      newLogicalOperators[id] = value;
      return {
        ...state,
        logicalOperators: newLogicalOperators,
      };
    }

    case 'DELETE_LOGICAL_OPERATOR': {
      const id = action.payload;

      const newLogicalOperators = [...state.logicalOperators];
      newLogicalOperators.splice(id, 1);
      return {
        ...state,
        logicalOperators: newLogicalOperators,
      };
    }

    case 'ADD_GROUP': {
      const id = action.payload;
      const updatedGroups = [...state.groups];
      const updatedConditions = { ...state.conditions };
      const childrenId = 'condition-' + Date.now();
      updatedGroups.push({
        id: 'condition-' + id,
        type: 'group',
        children: [{ id: childrenId, type: 'condition', children: [] }],
      });
      updatedConditions[childrenId] = {
        id: childrenId,
        attribute: [],
        variables: [],
        option: 'include',
      };
      const updatedOperators = { ...state.operators };
      adjustOperators(updatedGroups, updatedOperators);
      return {
        ...state,
        groups: updatedGroups,
        conditions: updatedConditions,
        operators: updatedOperators,
      };
    }

    case 'REMOVE_GROUP': {
      const id = action.payload;
      const groupsCopy = [...state.groups];
      const lastGroup = groupsCopy.filter(
        (group) => group.children?.length > 0
      ).length;
      const conditionsCopy = { ...state.conditions };
      // This option is invoked if user clicked on "Reset" button at the top of Advanced Builder header or
      // This is return statement if conditions/group that is being removed is the last one, so a 'placeholder' group will be returned in order not to leave the screen blank
      if (id === 'reset' || lastGroup < 2) {
        return {
          ...state,
          groups: [
            {
              id: 'main',
              type: 'group',
              children: [
                { id: 'condition-2', type: 'condition', children: [] },
              ],
            },
          ],
          conditions: {
            'condition-2': {
              id: 'condition-2',
              attribute: [],
              variables: [],
              option: 'include',
            },
          },
          operators: {},
        };
      }
      // This "normal" flow opiton - which means only one group will be removed.
      if (lastGroup > 1) {
        const { newGroups } = removeGroup(groupsCopy, conditionsCopy, id);
        const updatedOperators = { ...state.operators };
        adjustOperators(newGroups, updatedOperators);
        return {
          ...state,
          groups: newGroups,
          conditions: conditionsCopy,
          operators: updatedOperators,
        };
      }
    }
    // eslint-disable-next-line
    case 'UPDATE_OPERATOR': {
      const { value, id } = action.payload;
      const updatedOperators = { ...state.operators };
      const operatorToUpdate = { ...updatedOperators[id], value };
      return {
        ...state,
        operators: { ...updatedOperators, [id]: operatorToUpdate },
      };
    }

    case 'SET_QBFIELDS': {
      return {
        ...state,
        qbFields: action.payload,
      };
    }

    case 'SET_WORKFLOW_ID': {
      return {
        ...state,
        workflowId: action.payload,
      };
    }

    case 'CLEAR_WORKFLOW_ID': {
      return {
        ...state,
        workflowId: null,
      };
    }

    default:
      return state;
  }
};
